import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block no-underline mb-4">
              <span className="font-heading text-2xl font-bold text-foreground-950">
                Kakobuy<span className="text-primary-500">Polska</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mt-3">
              Twój przewodnik po świecie Kakobuy Spreadsheet. Znajdź najlepsze produkty, porównaj ceny i odkryj nowe okazje zakupowe.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg font-semibold text-foreground-950 mb-4">Poradniki SEO</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/blog/kakobuy-spreadsheet-polska-przewodnik" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline">Kompletny przewodnik</Link>
              <Link to="/blog/kakobuy-bezpieczenstwo" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline">Bezpieczeństwo Kakobuy</Link>
              <Link to="/blog/kakobuy-sneakers-spreadsheet" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline">Sneakers Spreadsheet</Link>
              <Link to="/blog/kakobuy-jak-korzystac" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline">Jak korzystać</Link>
              <Link to="/blog/kakobuy-dla-poczatkujacych" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline">Dla początkujących</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg font-semibold text-foreground-950 mb-4">Więcej artykułów</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/blog/najlepsze-produkty-kakobuy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline">Najlepsze produkty</Link>
              <Link to="/blog/kakobuy-hoodie-spreadsheet" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline">Hoodie Spreadsheet</Link>
              <Link to="/blog/kakobuy-wysylka-polska" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline">Wysyłka do Polski</Link>
              <Link to="/blog/kakobuy-opinie-recenzje" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline">Opinie i recenzje</Link>
              <Link to="/blog/kakobuy-finds-polska" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline">Finds Polska</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg font-semibold text-foreground-950 mb-4">Główna platforma</h4>
            <p className="text-sm text-foreground-600 mb-4 leading-relaxed">
              Przejdź do głównej platformy, aby przeglądać pełną ofertę produktów i dokonywać zakupów.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer no-underline"
            >
              <i className="ri-external-link-line"></i>
              Kakobuy Spreadsheet
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} KakobuyPolska.pics. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors no-underline">Kaspreadsheet.com</a>
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors no-underline">Strona główna</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}